import {css} from "@panda/css";

import {BrandOfferIcon} from "@pg-design/icons-module";
import {ResponsiveModal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {OfferType} from "../../../../offer/types/OfferType";
import {getUnlockChoicePropertyNoun} from "../../../utils/get_unlock_choice_property_noun";

interface IProps {
    titleId: string;
    descriptionId: string;
    offerType: OfferType | null;
}

export const UnlockChoiceModalPriceNegotiation = (props: IProps) => {
    const {titleId, descriptionId, offerType} = props;

    return (
        <div className={containerStyle}>
            <BrandOfferIcon width={72} height={72} className={illustrationStyle} />

            <div role="status" className={textStyle}>
                <Text as="h2" id={titleId} variant="headline_4" color="var(--colors-secondary)">
                    Cena jest za wysoka?
                </Text>

                <Text as="p" id={descriptionId} variant="body_copy_2" color="var(--colors-secondary)" className={descriptionStyle}>
                    Wielu deweloperów oferuje rabaty lub optymalne harmonogramy płatności. Zapytaj o niezobowiązującą ofertę i{" "}
                    <strong className={highlightStyle}>sprawdź ile możesz zyskać</strong> na tym {getUnlockChoicePropertyNoun(offerType).locative}.
                </Text>
            </div>

            <ResponsiveModal.CloseButton dataTestId={OFFER_TEST_IDS.LEAD_FORM.UNLOCK_CHOICE_PRICE_NEGOTIATION_CLOSE_BUTTON} />
        </div>
    );
};

const containerStyle = css({
    display: "flex",
    alignItems: "flex-start",
    columnGap: "1rem",
    px: 2,
    py: 1.5
});

const illustrationStyle = css({
    display: "block",
    flexShrink: 0
});

const textStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 1,
    flex: "1 1 auto",
    minWidth: 0
});

const descriptionStyle = css({
    lineHeight: "1.8rem",
    md: {
        lineHeight: "2rem"
    }
});

const highlightStyle = css({
    fontWeight: 700
});
import {css} from "@panda/css";

import {BrandOfferIcon} from "@pg-design/icons-module";
import {ResponsiveModal} from "@pg-design/modal-module";
import {Text} from "@pg-design/text-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";

import {OfferType} from "../../../../offer/types/OfferType";
import {getUnlockChoicePropertyNoun} from "../../../utils/get_unlock_choice_property_noun";

interface IProps {
    titleId: string;
    descriptionId: string;
    offerType: OfferType | null;
}

export const UnlockChoiceModalPriceNegotiation = (props: IProps) => {
    const {titleId, descriptionId, offerType} = props;

    return (
        <div className={containerStyle}>
            <BrandOfferIcon width={72} height={72} className={illustrationStyle} />

            <div role="status" className={textStyle}>
                <Text as="h2" id={titleId} variant="headline_4" color="var(--colors-secondary)">
                    Cena jest za wysoka?
                </Text>

                <Text as="p" id={descriptionId} variant="body_copy_2" color="var(--colors-secondary)" className={descriptionStyle}>
                    Wielu deweloperów oferuje rabaty lub optymalne harmonogramy płatności. Zapytaj o niezobowiązującą ofertę i{" "}
                    <strong className={highlightStyle}>sprawdź ile możesz zyskać</strong> na tym {getUnlockChoicePropertyNoun(offerType).locative}.
                </Text>
            </div>

            <ResponsiveModal.CloseButton dataTestId={OFFER_TEST_IDS.LEAD_FORM.UNLOCK_CHOICE_PRICE_NEGOTIATION_CLOSE_BUTTON} />
        </div>
    );
};

const containerStyle = css({
    display: "flex",
    alignItems: "flex-start",
    columnGap: "1rem",
    px: 2,
    py: 1.5
});

const illustrationStyle = css({
    display: "block",
    flexShrink: 0
});

const textStyle = css({
    display: "flex",
    flexDirection: "column",
    rowGap: 1,
    flex: "1 1 auto",
    minWidth: 0
});

const descriptionStyle = css({
    lineHeight: "1.8rem",
    md: {
        lineHeight: "2rem"
    }
});

const highlightStyle = css({
    fontWeight: 700
});
